import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FieldWrapper from 'cx-ui-components/src/components/ConfigUi/Field/FieldWrapper';

const FixedValue = styled.div`
  padding-top: 5px;
  height: 32px;
  font-weight: bold;
`;

// For holding unchangeable ArtifactType/Subtype vals
const FixedData = ({ label, value }) => <FieldWrapper label={label} children={<FixedValue>{value}</FixedValue>} />;

export default FixedData;
